export const cardManager = 'CardManagerIndex'
export const cardCashRecord = 'CardCashRecord'
export const cardScoreRecord = 'CardScoreRecord'
export const cardAuditRecord = 'CardAuditRecord'
export const payDealExport = 'PayDealExport'
export const rechargeDealExport = 'RechargeDealExport'
export const ticketExport = 'TicketExport'
export const productOrderExport = 'ProductOrderExport'
export const cardListExport = 'CardListExport'
export const delivery = 'Delivery'

export const createQrCoupon = 'CreateQrCoupon'
export const editQrCoupon = 'EditQrCoupon'
export const createBindMobileCoupon = 'CreateBindMobileCoupon'
export const editBindMobileCoupon = 'EditBindMobileCoupon'
export const createHomePopupCoupon = 'CreateHomePopupCoupon'
export const editHomePopupCoupon = 'EditHomePopupCoupon'

export const createOpenCardCoupon = 'CreateOpenCardCoupon'
export const editOpenCardCoupon = 'EditOpenCardCoupon'
export const createRechargeCoupon = 'CreateRechargeCoupon'
export const editRechargeCoupon = 'EditRechargeCoupon'

export const createOfflineCoupon = 'CreateOfflineCoupon'
export const editOfflineCoupon = 'EditOfflineCoupon'
export const detailOfflineCoupon = 'LookOfflineCoupon'

export const createOpenCardRule = 'CreateOpenCardRule'
export const editOpenCardRule = 'EditOpenCardRule'
export const createRechargeRule = 'CreateRechargeRule'
export const editRechargeRule = 'EditRechargeRule'

export const createHoliday = 'CreateHoliday'
export const editHoliday = 'EditHoliday'

export const userExport = 'UserExport'

export const productOrder = 'ProductOrder'
export const ticketOrder = 'TicketOrder'
